import { Link } from 'react-router-dom';
import {
	getButtonClassNames,
	cn,
	outlineCtaOuterClassNames,
	outlineCtaInnerClassNames,
} from './buttonStyles';
import { renderButtonInnerContent } from './Button';

/**
 * Misma API visual que `Button`, renderiza `Link` para navegación declarativa.
 */
export const ButtonLink = ({
	to,
	replace,
	state,
	children,
	icon = null,
	iconPosition = 'start',
	className = '',
	variant = 'primary',
	size = 'md',
	fullWidth = false,
	labelCase = 'sentence',
	...rest
}) => {
	const inner = renderButtonInnerContent({ children, icon, iconPosition, labelCase });

	if (variant === 'outlineCta') {
		return (
			<Link
				to={to}
				replace={replace}
				state={state}
				className={cn(outlineCtaOuterClassNames, className)}
				{...rest}
			>
				<span className={outlineCtaInnerClassNames}>{inner}</span>
			</Link>
		);
	}

	return (
		<Link
			to={to}
			replace={replace}
			state={state}
			className={cn(getButtonClassNames({ variant, size, fullWidth }), className)}
			{...rest}
		>
			{variant === 'gradient' ? (
				<>
					<span className="relative z-10 inline-flex items-center justify-center gap-2">{inner}</span>
					<div
						className="pointer-events-none absolute inset-0 bg-gradient-to-r from-purple-600 to-indigo-600 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
						aria-hidden
					/>
				</>
			) : (
				inner
			)}
		</Link>
	);
};
